import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconHome = props => {
    return (
        <SvgIcon viewBox="0 0 16 16" fontSize="small" {...props}>
            <path
                d="M15.581,5.186l-7-5a1,1,0,0,0-1.162,0l-7,5A1,1,0,0,0,1.581,6.814L2,6.515V15a1,1,0,0,0,1,1H13a1,1,0,0,0,1-1V6.515A1.7,1.7,0,0,0,15,7a1,1,0,0,0,.582-1.814ZM12,14H10V11a2,2,0,0,0-4,0v3H4V5.086L8,2.229l4,2.857Z"
                transform="translate(0 0)"
            />
        </SvgIcon>
    );
};
